import { Pipe, PipeTransform } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { IDate } from '../../../../../core/interfaces/datepicker-date';

@Pipe({
  name: 'isEndDate',
  standalone: false
})
export class IsEndDatePipe implements PipeTransform {
  transform(date: NgbDate, fromDate: IDate, toDate: IDate, hoveredDate: IDate): any {
    return (
      date.equals(toDate) ||
      (!toDate && fromDate && hoveredDate && !date.equals(fromDate) && date.after(fromDate) && date.equals(hoveredDate))
    );
  }
}
